import { useState } from "react";
import { IoMdArrowDropdownCircle, IoMdArrowDropupCircle  } from "react-icons/io";

import { toolbarActions  } from '../../services/EnumsService';
import ToolbarOptionComponent from '../toolbar/ToolbarOptionComponent';
import ToolbarComponent from "../toolbar/ToolbarComponent";
import { SubtaskModal } from "./SubtaskModal";
import { CategoryData } from "../../pages/Category/CategoryWrapper";
import { subtaskOrderUp, subtaskOrderDown, subtaskStart, subtaskFinish, subtaskCancel, subtaskDelete } from "../../api/subtask.api";
import { showError } from "../../services/toastServices";
import { subtaskStatusEnum } from "../../services/EnumsService";
import ExpandablePanel from "../ExpandablePanel";

export default function ExpandableSubtaskComponent({subtask, isFirst, isLast}) {
    const [showSubtaskModal, setShowSubtaskModal] = useState(false)
    const {category, refreshProjectsCategory} = CategoryData();

    const editSubtaskCloseAction = (()=>{
        setShowSubtaskModal(false)
    })
    const editSubtaskAction = (()=>{
        setShowSubtaskModal(true)
    })

    const orderUp = (async ()=>{
        await subtaskOrderUp(subtask.id, orderError);
        refreshProjectsCategory();
    })

    const orderDown = (async ()=>{
        await subtaskOrderDown(subtask.id, orderError);
        refreshProjectsCategory();
    })

    const orderError = ((error)=>{
        showError(`Error al cambiar el orden de la tarea. ${error.message}`)

    })
    const changeStatusError = ((error)=>{
        showError(`Error al cambiar el estado de la tarea. ${error.message}`)

    })

    const renderUpButton = (()=>{
        if(isFirst)
            return (<div className="text-xl font-bold"><IoMdArrowDropupCircle color="gray"  /> </div>)
        else
            return (<div className="text-xl font-bold cursor-pointer" onClick={orderUp} ><IoMdArrowDropupCircle /> </div>)
    })

    const renderDownButton = (()=>{
        if(isLast)
            return (<div className="text-xl font-bold" ><IoMdArrowDropdownCircle color="gray" /></div>)
        else
            return (<div className="text-xl font-bold cursor-pointer" onClick={orderDown} ><IoMdArrowDropdownCircle /></div>)
    })

    const editSubtaskModal = (<SubtaskModal subtaskId={subtask.id} closeAction={editSubtaskCloseAction}></SubtaskModal>)
    const startSubtaskAction =(async ()=>{
        await subtaskStart(subtask.id, changeStatusError)
        refreshProjectsCategory();
    })

    const finishSubtaskAction =(async ()=>{
        await subtaskFinish(subtask.id, changeStatusError)
        refreshProjectsCategory();
    })

    const cancelSubtaskAction =(async ()=>{
        await subtaskCancel(subtask.id, changeStatusError)
        refreshProjectsCategory();
    })
    const deleteSubtaskAction =(async ()=>{
        await subtaskDelete(subtask.id, changeStatusError)
        refreshProjectsCategory();
    })

    const orderButtons = (
        <div key={subtask.id} className="flex flex-row">
            <div className="flex flex-row">
                {renderUpButton()}
                {renderDownButton()}
            </div>
        </div>
    );

    const header = (
        <div key={subtask.id} className="flex flex-row">
            {/* <div className='mr-1 rounded-full px-2 text-sm' style={{ backgroundColor: `${subtaskStatusEnum(subtask.status).color}`}}>{subtaskStatusEnum(subtask.status).shortStatus} </div> */}
            <div className="flex flex-col">
                <div className='ml-2 text-xl rounded-md px-2' style={{ backgroundColor: `${subtaskStatusEnum(subtask.status).color}`}}>{subtask.name}</div>                
            </div>
        </div>

    )

    return (
        <div>
            {showSubtaskModal && editSubtaskModal}

            <ExpandablePanel key={subtask.id} header={header} orderButtons={orderButtons}>
                <ToolbarComponent className='mb-2'>
                    <ToolbarOptionComponent title={'Editar'} size={20} icon={toolbarActions.Edit} clickAction={editSubtaskAction}/>
                    <ToolbarOptionComponent title={'Iniciar'} size={20} icon={toolbarActions.Start} clickAction={startSubtaskAction}/>
                    <ToolbarOptionComponent title={'Finalizar'} size={20} icon={toolbarActions.Finish} clickAction={finishSubtaskAction}/>
                    <ToolbarOptionComponent title={'Cancelar'} size={20} icon={toolbarActions.Cancel} clickAction={cancelSubtaskAction}/>
                    <ToolbarOptionComponent title={'Eliminar'} size={20} icon={toolbarActions.Delete} clickAction={deleteSubtaskAction}/>
                </ToolbarComponent>
                <div className='text-l '>{subtask.description}</div>
            </ExpandablePanel>
        </div>
    )
}